import { CURRENCIES } from 'src/features/payStations/types';
import { RESERVATION_TYPE } from 'src/features/reservations/types/reservationType';

export enum ADDITIONAL_SERVICES_TYPE {
    SERVICE_CHARGE = 'service_charge',
    CANCELLATION_OPTION = 'cancellation_option',
}

export enum ADDITIONAL_SERVICES_USED_FOR {
    RESERVATION = 'reservation',
    SUBSCRIPTION = 'subscription',
    VEHICLE_STAY = 'vehicle_stay',
}

export type AdditionalServices = {
    id: number;
    price: number;
    tax_amount: number;
    type: ADDITIONAL_SERVICES_TYPE;
    used_for: ADDITIONAL_SERVICES_USED_FOR;
    reservation_types: RESERVATION_TYPE[];
    is_optional: boolean;
    is_enabled: boolean;
    name: string;
    description: string | null;
    currency: CURRENCIES;
    tax_percent: string;
    price_with_tax: number;
    valid_from: string;
    valid_to: string | null;
    is_used: boolean;
};
